import { createFileRoute } from '@tanstack/react-router';

import { DeliverablesPage } from '@/features/design/deliverables-page';

export const Route = createFileRoute('/_app/projects/$projectId/design/deliverables')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <DeliverablesPage projectId={projectId} />;
}
